import React from 'react';
import { teamData } from '../data';
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from '../variants';

const Team = () => {

  const { pretitle, title, signatureImg, TeamImg, occupation, sub1 } = teamData;

  return (
    <section id='our team' className='cursor-default relative h-auto lg:min-h-[110vh] bg-tmb bg-fixed bg-cover overflow-hidden'>
      <div className="absolute top-0 right-0 bottom-0 left-0 bg-black bg-opacity-70" />

      <div className='container mx-auto my-8'>

        <motion.div 
        variants={staggerContainer}
        initial='hidden'
        whileInView={'show'}
        viewport={{once: false, amount: 0.2}}
        className='relative z-10 text-center flex flex-col lg:flex-row lg:gap-x-[120px] 
        items-center lg:content-center'>

          <motion.div 
          variants={fadeIn('right', 'spring', 0.3, 1.3)} 
          className='bg-accent flex-1 my-10'>
            <img src={TeamImg} />
          </motion.div>
          
          <motion.div className='flex-1 text-center lg:text-left lg:pt-20'>
            <motion.div variants={fadeIn('down', 'tween', 0.3, 1.1)} className='pretitle'>{pretitle}</motion.div>
            <motion.h2 variants={fadeIn('down', 'tween', 0.4, 1.1)} className='h2 capitalize text-white'>{title}</motion.h2>
            <motion.p variants={fadeIn('down', 'tween', 0.5, 1.1)} className='mb-[20px] text-white'>{sub1}</motion.p>

            <motion.div variants={fadeIn('down', 'tween', 0.5, 1.1)} className='my-0'>
              <div className='text-2xl text-accent font-semibold'>{occupation}</div>
            </motion.div>

            <motion.div variants={fadeIn('up', 'tween', 0.3, 1.3)} className='flex justify-center lg:justify-start my-10'>
              <img className='w-auto lg:w-[430px] h-[71px]' src={signatureImg} />
            </motion.div>
          </motion.div>

        </motion.div>

      </div>

    </section>
  );
};

export default Team;
